import ImagesModule from './Module'
import { IUseImages } from './types'

const useImages: IUseImages = () => ImagesModule

export default useImages
